/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.defs'

type $nsid = typeof $nsid

export { $nsid }

type JobStatus = {
  $type?: 'app.bsky.video.defs#jobStatus'
  jobId: string
  did: l.DidString

  /**
   * The state of the video processing job. All values not listed as a known value indicate that the job is in process.
   */
  state:
    | 'JOB_STATE_CREATED'
    | 'JOB_STATE_ENCODING'
    | 'JOB_STATE_ENCODED'
    | 'JOB_STATE_SCANNING'
    | 'JOB_STATE_SCANNED'
    | 'JOB_STATE_UPLOADING'
    | 'JOB_STATE_UPLOADED'
    | 'JOB_STATE_COMPLETED'
    | 'JOB_STATE_FAILED'
    | l.UnknownString

  /**
   * Progress within the current processing state.
   */
  progress?: number
  blob?: l.BlobRef
  error?: string

  /**
   * A machine-readable code for why the video processing job failed.
   */
  failureCode?:
    | 'validation_failure'
    | 'encoding_failure'
    | 'pds_upload_failure'
    | 'pds_upload_unsupported_blob_size'
    | 'generic_failure'
    | l.UnknownString
  message?: string
}

export type { JobStatus }

const jobStatus = /*#__PURE__*/ l.typedObject<JobStatus>(
  $nsid,
  'jobStatus',
  /*#__PURE__*/ l.object({
    jobId: /*#__PURE__*/ l.string(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    state: /*#__PURE__*/ l.string<{
      knownValues: [
        'JOB_STATE_CREATED',
        'JOB_STATE_ENCODING',
        'JOB_STATE_ENCODED',
        'JOB_STATE_SCANNING',
        'JOB_STATE_SCANNED',
        'JOB_STATE_UPLOADING',
        'JOB_STATE_UPLOADED',
        'JOB_STATE_COMPLETED',
        'JOB_STATE_FAILED',
      ]
    }>(),
    progress: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 100 }),
    ),
    blob: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.blob()),
    error: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    failureCode: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'validation_failure',
          'encoding_failure',
          'pds_upload_failure',
          'pds_upload_unsupported_blob_size',
          'generic_failure',
        ]
      }>(),
    ),
    message: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { jobStatus }
